///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2024 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import messages from "./messages";

export const getDefaultOptionForOpportunityName = () => {
  let option = [];
  option.push({
    value: -2,
    label: messages.createOpportunityInRevv.defaultMessage,
    url: window.REACT_APP_REVV_WEB_CLIENT_URL
  });

  return option;
};

export default getDefaultOptionForOpportunityName;
